import { useEffect } from 'react'
import { authPort } from '@/infra/config/beans'

const SilentRenewPage = () => {
  useEffect(() => {
    authPort.handleSilentRenew().catch((err: Error) => {
      console.error('Silent renew error:', err)
    })
  }, [])

  return null
}

export default SilentRenewPage
